module.exports = __webpack_public_path__ + "img/ken.eb0db234.png";